var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    style: _vm.style
  }, [_c('loading-overlay', {
    attrs: {
      "wait-for": true,
      "light": true,
      "hide-loader": _vm.reason,
      "reason": _vm.reason
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/extra-logo-black.svg"),
      "alt": "Extra logo"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };